module.exports = __webpack_public_path__ + "img/Pierce.ac859a28.jpg";